/**
 * Helpers for multi-tag prayer categories.
 */

const CATEGORY_ORDER = ['healing', 'finances', 'family', 'spiritual', 'other'] as const;

export type PrayerCategory = (typeof CATEGORY_ORDER)[number];

export const CATEGORY_OPTIONS: { value: PrayerCategory; label: string }[] = [
  { value: 'healing', label: 'Healing' },
  { value: 'finances', label: 'Finances' },
  { value: 'family', label: 'Family' },
  { value: 'spiritual', label: 'Spiritual' },
  { value: 'other', label: 'Other' },
];

/**
 * Resolve the full category list from a prayer payload.
 * Prefers `categories`; falls back to a one-element list from primary `category`.
 */
export function getPrayerCategories(prayer: {
  categories?: string[] | null;
  category?: string | null;
}): string[] {
  if (Array.isArray(prayer.categories) && prayer.categories.length > 0) {
    return prayer.categories;
  }
  if (prayer.category) {
    return [prayer.category];
  }
  return [];
}

/** Stable equality for category tag lists (order-insensitive). */
export function categoriesEqual(a: string[], b: string[]): boolean {
  if (a.length !== b.length) return false;
  const setB = new Set(b);
  return a.every((c) => setB.has(c));
}

/** Deduplicate and order tags in CATEGORY_ORDER. */
export function normalizeCategories(selected: string[]): string[] {
  const seen = new Set<string>();
  const result: string[] = [];
  for (const cat of CATEGORY_ORDER) {
    if (selected.includes(cat) && !seen.has(cat)) {
      result.push(cat);
      seen.add(cat);
    }
  }
  return result;
}
